<ng-container *ngFor="let field of headerFieldGroup">
    <div class="p-m-1 p-px-2">
      <span class="p-text-bold p-mr-2">{{ field.name }}:</span>
      <span *ngIf="entity[field.key]" class="p-text-normal">
        {{ entity[field.key] }}
      </span>
    </div>
  </ng-container>
  